import React from "react";
import { Button } from "primereact/button";
import { USERTYPE } from "../../constants/USERTYPE";
import { Translate } from "react-auto-translate";

//redux
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const ViewRecentActivityBlock = (props) => {
  const { isCurrentUser } = props;

  const userState = useSelector((state) => state.user);

  const posts = [];

  return (
    <div className="p-3 bg-white mt-4 border-round">
      <div className="flex justify-content-between align-items-center">
        <h2>
          <Translate>Recent Activity</Translate>
        </h2>
      </div>

      <div>
        {props.isGuest ? (
          <h2>
            <Translate>Login/Sign up to see this user's posts</Translate>
          </h2>
        ) : (
          <Link to={`/posts/${userState.user.id}`} className="no-underline">
            <Button
              className={`w-12 ${
                userState.user.userType === USERTYPE.ENTREPRENEUR
                  ? "bg-primary-500 hover:bg-primary-400"
                  : userState.user.type === USERTYPE.INVESTOR
                  ? "bg-blue-500 hover:bg-blue-400"
                  : "bg-cyan-500 hover:bg-cyan-400"
              } border-none`}
              label={<Translate>Click to see all posts</Translate>}
            />
          </Link>
        )}
      </div>
    </div>
  );
};
